import { useEffect } from 'react';

let originalFavicons = [];
let channel = null;
let isStale = false;
let currentPortfolioGroupID = null;

export const initializeStaleTabWarning = selectedPortfolioGroupID => {
	// Store original favicons on first initialization
	if (originalFavicons.length === 0) {
		const favicons = document.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]');
		originalFavicons = Array.from(favicons).map(favicon => ({
			rel: favicon.rel || '',
			type: favicon.type || '',
			href: favicon.href || '',
			sizes: favicon.sizes ? favicon.sizes.toString() : ''
		}));
	}

	// Initialize broadcast channel
	if (!channel) {
		channel = new BroadcastChannel('pod-sync');
		channel.addEventListener('message', handlePodChange);
	}

	currentPortfolioGroupID = selectedPortfolioGroupID;

	// Clear stale status if portfolio group ID is valid
	if (selectedPortfolioGroupID !== null && isStale) {
		isStale = false;
		restoreOriginalFavicon();
	}
};

const handlePodChange = event => {
	if (event.data.type === 'POD_CHANGED') {
		const broadcastedPodID = event.data.newPodID;

		if (broadcastedPodID !== currentPortfolioGroupID) {
			isStale = true;
			setWarningFavicon();
		} else {
			isStale = false;
			restoreOriginalFavicon();
		}
	}
};

const setWarningFavicon = () => {
	// Remove existing warning favicons
	document.querySelectorAll('link[data-stale-warning="true"]').forEach(favicon => favicon.remove());

	// Remove original favicons
	document.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]').forEach(favicon => {
		if (!favicon.hasAttribute('data-stale-warning')) {
			favicon.remove();
		}
	});

	// Add warning favicon
	const favicon = document.createElement('link');
	favicon.rel = 'icon';
	favicon.type = 'image/svg+xml';
	favicon.href = '/assets/favicon/triangle-alert.svg?v=' + Date.now();
	favicon.setAttribute('data-stale-warning', 'true');

	document.head.insertBefore(favicon, document.head.firstChild);
};

const restoreOriginalFavicon = () => {
	// Remove warning favicons
	document.querySelectorAll('link[data-stale-warning="true"]').forEach(favicon => favicon.remove());

	// Restore original favicons
	originalFavicons.forEach(faviconData => {
		const favicon = document.createElement('link');
		favicon.rel = faviconData.rel;
		favicon.type = faviconData.type;
		favicon.href = faviconData.href;
		if (faviconData.sizes) {
			favicon.sizes = faviconData.sizes;
		}
		document.head.insertBefore(favicon, document.head.firstChild);
	});
};

export const cleanupStaleTabWarning = () => {
	if (channel) {
		channel.removeEventListener('message', handlePodChange);
		channel.close();
		channel = null;
	}

	restoreOriginalFavicon();
	originalFavicons = [];
	isStale = false;
};

export const useStaleTabWarning = selectedPortfolioGroupID => {
	useEffect(() => {
		initializeStaleTabWarning(selectedPortfolioGroupID);

		return cleanupStaleTabWarning;
	}, [selectedPortfolioGroupID]);
};
